import React from 'react'

export default function CTAButton() {
    return (
        <div className="form-group col-sm-6 col-xs-12">
            <button className="btn btn-border-w btn-circle btn-block" id="racSubmit" type="submit"><i className="fa fa-paper-plane-o" /> Submit</button>
        </div>
    )
}
